import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { wrapIntrospect } from '@adornis/introspect/server/introspect.js';
import { runExtractionByMail } from './mail-content-extraction-agent/server/extraction-runner.js';

export const extractMailInformation = registerMutation({
  type: () => String,
  operationName: 'extractMailInformation',
  resolve: (mailID: string) => {
    return async () => {
      console.log('Extract mail information for mailID:', mailID);
      // dreckig diese
      wrapIntrospect('extractMailInformation', async ({ mailID }) => {
        await wrapIntrospect('analyzeMailContent', runExtractionByMail)(mailID);
      })({ mailID });
    };
  },
  params: [{ name: 'mailID', type: () => String }],
});
